
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';

export default function RaceModalities() {
  const { t } = useTranslation();

  const fadeInUp = {
    initial: { opacity: 0, y: 40 },
    whileInView: { opacity: 1, y: 0 },
    viewport: { once: true },
    transition: { duration: 0.6 },
  };

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div {...fadeInUp} className="text-center mb-20">
          <h2 className="font-futura font-black text-4xl sm:text-5xl md:text-6xl text-primary mb-6">
            {t('common:races.title')}
          </h2>
          <div className="w-32 h-1 bg-primary mx-auto"></div>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10">
          {/* Skyrace Card */}
          <motion.div
            {...fadeInUp}
            transition={{ delay: 0.2 }}
            className="bg-white rounded-3xl shadow-xl overflow-hidden hover:shadow-2xl transition-all duration-300 hover:-translate-y-2"
          >
            <div className="relative h-80">
              <img
                src="https://static.readdy.ai/image/0d2a8bbfaad65247a8e821bed673477a/fd46c4435c22937489c1b95266c1efbc.jpeg"
                alt="Sinjavina Skyrace"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute top-4 left-4">
                <span className="bg-primary text-white font-futura font-bold text-xs px-4 py-2 rounded-full">
                  {t('common:races.skyrace.badge')}
                </span>
              </div>
            </div>
            <div className="p-8">
              <h3 className="font-futura font-black text-3xl text-gray-900 mb-6">
                {t('common:races.skyrace.title')}
              </h3>
              <div className="grid grid-cols-2 gap-4 mb-6">
                <div className="flex items-center gap-2">
                  <i className="ri-route-line text-2xl text-primary"></i>
                  <span className="text-gray-700 text-sm">{t('common:races.skyrace.distance')}</span>
                </div>
                <div className="flex items-center gap-2">
                  <i className="ri-mountain-line text-2xl text-primary"></i>
                  <span className="text-gray-700 text-sm">{t('common:races.skyrace.elevation')}</span>
                </div>
                <div className="flex items-center gap-2">
                  <i className="ri-timer-line text-2xl text-primary"></i>
                  <span className="text-gray-700 text-sm">{t('common:races.skyrace.timeLimit')}</span>
                </div>
                <div className="flex items-center gap-2">
                  <i className="ri-arrow-up-line text-2xl text-primary"></i>
                  <span className="text-gray-700 text-sm">{t('common:races.skyrace.maxAltitude')}</span>
                </div>
              </div>
              <p className="text-gray-600 text-base leading-relaxed mb-8">
                {t('common:races.skyrace.description')}
              </p>
              <a
                href="https://www.avaibooksports.com/inscripcion/sinjavina-skyrace/inscripcion_datos/?cod_cuota=89693"
                target="_blank"
                rel="noopener noreferrer"
                className="block w-full bg-primary hover:bg-primary-dark text-white font-futura font-bold text-center py-4 rounded-xl transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer"
              >
                {t('common:races.skyrace.button')}
              </a>
            </div>
          </motion.div>

          {/* Mini Skyrace Card */}
          <motion.div
            {...fadeInUp}
            transition={{ delay: 0.4 }}
            className="bg-white rounded-3xl shadow-xl overflow-hidden hover:shadow-2xl transition-all duration-300 hover:-translate-y-2"
          >
            <div className="relative h-80">
              <img
                src="https://static.readdy.ai/image/0d2a8bbfaad65247a8e821bed673477a/756ecfba8256b7a8ca310c1fb619fb0e.jpeg"
                alt="Sinjavina Mini Skyrace"
                className="w-full h-full object-cover object-center"
              />
              <div className="absolute top-4 left-4">
                <span className="bg-primary/70 text-white font-futura font-bold text-xs px-4 py-2 rounded-full">
                  {t('common:races.miniSkyrace.badge')}
                </span>
              </div>
            </div>
            <div className="p-8">
              <h3 className="font-futura font-black text-3xl text-gray-900 mb-6">
                {t('common:races.miniSkyrace.title')}
              </h3>
              <div className="grid grid-cols-2 gap-4 mb-6">
                <div className="flex items-center gap-2">
                  <i className="ri-route-line text-2xl text-primary"></i>
                  <span className="text-gray-700 text-sm">{t('common:races.miniSkyrace.distance')}</span>
                </div>
                <div className="flex items-center gap-2">
                  <i className="ri-mountain-line text-2xl text-primary"></i>
                  <span className="text-gray-700 text-sm">{t('common:races.miniSkyrace.elevation')}</span>
                </div>
                <div className="flex items-center gap-2">
                  <i className="ri-timer-line text-2xl text-primary"></i>
                  <span className="text-gray-700 text-sm">{t('common:races.miniSkyrace.timeLimit')}</span>
                </div>
                <div className="flex items-center gap-2">
                  <i className="ri-arrow-up-line text-2xl text-primary"></i>
                  <span className="text-gray-700 text-sm">{t('common:races.miniSkyrace.maxAltitude')}</span>
                </div>
              </div>
              <p className="text-gray-600 text-base leading-relaxed mb-8">
                {t('common:races.miniSkyrace.description')}
              </p>
              <a
                href="https://www.avaibooksports.com/inscripcion/sinjavina-skyrace/inscripcion_datos/?cod_cuota=89694"
                target="_blank"
                rel="noopener noreferrer"
                className="block w-full bg-primary hover:bg-primary-dark text-white font-futura font-bold text-center py-4 rounded-xl transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer"
              >
                {t('common:races.miniSkyrace.button')}
              </a>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
